module.exports = __webpack_public_path__ + "img/menu-food-3.26e69d55.webp";